/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, useCallback, useContext, useState } from 'react';

import { IToastProps } from '../interfaces/i-toast-props';
import { IFCWithChildren } from '../interfaces/i-fc-with-children';
import { Toast } from '../components/Toast';

interface IToastContextData {
  showToast: (call: IToastProps) => void;
}

const ToastContext = createContext({} as IToastContextData);

const ToastProvider: IFCWithChildren = ({ children }) => {
  const [toastData, setToastData] = useState<IToastProps>({} as IToastProps);

  const showToast = useCallback((data: IToastProps) => {
    setToastData({
      ...data,
      id: Date.now(),
    });
  }, []);

  return (
    <ToastContext.Provider
      value={{
        showToast,
      }}
    >
      <Toast
        id={toastData.id}
        severity={toastData?.severity}
        description={toastData?.message}
        title={toastData?.title}
      />
      {children}
    </ToastContext.Provider>
  );
};

const useToast = (): IToastContextData => {
  return useContext(ToastContext);
};

export { ToastProvider, useToast };
